import { cva } from 'class-variance-authority'
import { useContext } from 'react'

import { Toast as ToastComponent } from './Toast'
import { ToastContext } from './ToastProvider'
import { CustomToast, StandardToast } from './types'
const toastContainerVariants = cva('pointer-events-auto relative', {
  variants: {
    position: {
      top: 'self-start mt-10',
      center: 'self-center',
    },
  },
})
export function ToastContainer() {
  const context = useContext(ToastContext)

  if (!context) {
    return null
  }

  const { toasts, removeToast } = context

  if (toasts.length === 0) {
    return null
  }

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) {
      // Close the most recent toast when clicking on overlay
      if (toasts.length > 0) {
        removeToast(toasts[toasts.length - 1].id)
      }
    }
  }
  return (
    <div className='fixed inset-0 z-[1000] flex items-center justify-center' onClick={handleOverlayClick}>
      <div className='pointer-events-auto fixed inset-0 bg-black/15' onClick={handleOverlayClick} />
      {toasts.map(toast => {
        if (toast.type === 'custom' || 'component' in toast) {
          const customToast = toast as CustomToast
          const closeToast = () => removeToast(toast.id)
          const component = typeof customToast.component === 'function' ? customToast.component(closeToast) : customToast.component

          return (
            <div
              key={toast.id}
              className={toastContainerVariants({ position: toast.options?.position })}
              style={{
                animation: 'fadeIn 0.2s ease-out',
              }}
            >
              {customToast.options?.showCloseButton !== false && (
                <button
                  className='absolute end-2 top-2 z-10 flex size-6 cursor-pointer items-center justify-center rounded-full border-none bg-transparent text-xl text-[#666] transition-colors hover:bg-black/5 hover:text-[#1c1c1c]'
                  onClick={closeToast}
                  aria-label='Close toast'
                >
                  ×
                </button>
              )}
              {component}
            </div>
          )
        }

        const standardToast = toast as StandardToast
        return (
          <div
            key={toast.id}
            className={toastContainerVariants({ position: toast.options?.position })}
            style={{
              animation: 'fadeIn 0.2s ease-out',
            }}
          >
            <ToastComponent toast={standardToast} onClose={() => removeToast(toast.id)} />
          </div>
        )
      })}
    </div>
  )
}
